import { gql } from "@apollo/client";

export const LOAD_LEFT_COLUMN = gql`
  query LoadLeftColumn($take: Int, $favorite: Boolean, $published: Boolean) {
    projects(take: $take, published: false) {
      items {
        id
        name
        preview
        isFavorite
      }
    }
    published: projects(take: $take, published: $published) {
      items {
        id
        name
        preview
        isFavorite
      }
    }
    favoriteProjects: projects(take: $take, favorite: $favorite) {
      items {
        id
        name
        preview
        isFavorite
      }
    }
  }
`;

export const LOAD_PROJECTS = gql`
  query LoadProjects(
    $published: Boolean
    $favorite: Boolean
    $isGroup: Boolean
    $take: Int
    $page: Int
  ) {
    projects(
      take: $take
      page: $page
      published: $published
      favorite: $favorite
      isGroup: $isGroup
    ) {
      items {
        id
        name
        preview
        isFavorite
        published
        isGroup
        user {
          id
        }
      }
      total
    }
  }
`;

export const LOAD_PROJECT = gql`
  query LoadProject($id: Int!) {
    project(id: $id) {
      id
      name
      ids
      types,
      textures
      groups
      scales {
        x
        y
        z
      }
      offsets {
        x
        y
        z
      }
      rotations
      camera {
        position {
          x
          y
          z
        }
        rotation {
          x
          y
          z
        }
      }
      models {
        sketchUrl
        sketchUrl2
        path3D {
          dirname
          obj
          mtl
        }
      }
    }
  }
`;

export const NEW_PROJECTS_SUBSCRIPTION = gql`
  subscription newProjects {
    newProject {
      id
      name
      preview
    }
  }
`;

export const DELETE_PROJECT = gql`
  mutation DeleteProject($id: Int!) {
    deleteProject(id: $id) {
      id
    }
  }
`;

export const PROJECTS_DELETED_SUBSCRIPTION = gql`
  subscription DeletedProjects {
    deletedProject {
      id
      name
      preview
    }
  }
`;

export const SET_FAVORITE = gql`
  mutation setFavorites($id: Int!, $value: Boolean!) {
    setFavorites(id: $id, value: $value)
  }
`;

export const SET_PUBLISH = gql`
  mutation setPublish($id: Int!, $value: Boolean!) {
    setPublish(id: $id, value: $value)
  }
`;

export const SAVE_PROJECT = gql`
  mutation SaveProject(
    $name: String!
    $preview: Upload!
    $ids: [Int]
    $types: [String]
    $textures: [String]
    $offsets: [String]
    $rotations: [Int]
    $camera: String!
    $scales: [String]!
    $groups: [String]!
  ) {
    saveProject(
      name: $name
      preview: $preview
      ids: $ids
      types: $types
      textures: $textures
      offsets: $offsets
      scales: $scales
      rotations: $rotations
      camera: $camera
      groups: $groups
    ) {
      id
      name
      preview
      isFavorite
      published
    }
  }
`;

export const GROUPS_QUERY = gql`
  query LoadGroups {
    groups {
      items {
        id
        name
        preview
      }
      total
    }
  }
`;

export const LOAD_GROUP = gql`
  query LoadGroup($id: Int!) {
    group(id: $id) {
      id
      name
      ids
      types
      offsets {
        x
        y
        z
      }
      rotations
      models {
        path3D {
          dirname
          obj
          mtl
        }
      }
    }
  }
`;

export const SAVE_GROUP = gql`
  mutation SaveGroup(
    $name: String!
    $preview: Upload!
    $ids: [Int]!
    $types: [String]!
    $offsets: [String]!
    $scales: [String]!
    $rotations: [Int]!
    $groups: [String]!
  ) {
    saveGroup(
      name: $name
      preview: $preview
      ids: $ids
      types: $types
      offsets: $offsets
      rotations: $rotations
    ) {
      id
      name
    }
  }
`;
